module.exports = __webpack_public_path__ + "img/11.c86a1032.png";